import { create as r } from "zustand";
import { devtools as p, persist as s } from "zustand/middleware";
const a = r()(
  p(
    s(
      (e) => ({
        isOpen: !1,
        modalProps: void 0,
        openCropper: (o) => e(() => ({ isOpen: !0, modalProps: o })),
        closeCropper: () => e(() => ({ isOpen: !1, modalProps: void 0 }))
      }),
      {
        name: "cropper-modal"
      }
    )
  )
);
export {
  a as useCropperModalStore
};
